import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
// import leaf from "../../Assets/Projects/leaf.png";
// import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
// import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="React Admin"
              description="Is an admin panel that enables administrators of the application, website, or IT system to manage its configurations, settings, content, and features and carry out oversight functions critical to the business. It allows them to view the state of the platform and take any action in the performance of their duties."
              ghLink="https://github.com/Musaiyib/React-Admin"

              demoLink="https://github.com/Musaiyib/React-Admin"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="E-voting"
              description="This e-voting website is design to take over any selfish intrest during election and is design under university association. It uses student registration number to generate and validate token that will be use for each student before allowing the student to navigate to the voting page, the vote counter uses live update."
              ghLink="https://github.com/Musaiyib/evoting-frontend"
              demoLink="https://blogs.soumya-jit.tech/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Editor.io"
              description="Online payment management build to manage local payment detail for graduating student in university, it help the manager to calculate the amount paid and the total student that pay, It also filter those that make part payment and show their remaining balance"
              ghLink="https://github.com/Musaiyib/Grad-payment-React/"
              demoLink="https://editor.soumya-jit.tech/"
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
